import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'

export function findByPage(data?: any) {
  return request.post<AxiosResult>('/lbu/api/zhiQuLog/findByPage', data)
}
